// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1kvXo","info":"Note_info__2MQDB","note":"Note_note__20Jns","actions":"Note_actions__1X0eQ"};